export default (retailers) =>
  retailers.map((retailer) => ({
    text: retailer.title,
    value: retailer.id,
  }));
